// extracted by mini-css-extract-plugin
export var profile_card = "ProfileCard-module--profile_card--xPb9I";
export var profile_card_header = "ProfileCard-module--profile_card_header--zY33p";
export var profile_card_cover = "ProfileCard-module--profile_card_cover--liE6F";
export var profile_card_avatar = "ProfileCard-module--profile_card_avatar--xtBMt";
export var profile_card_info = "ProfileCard-module--profile_card_info--xAylN";
export var profile_card_name = "ProfileCard-module--profile_card_name--sJwmJ";
export var profile_card_subname = "ProfileCard-module--profile_card_subname--lVEAK";